import { Box } from "@chakra-ui/react";
import Field from "ui/components/Input/Field";
import { Checkbox } from "@chakra-ui/checkbox";
import CollapseSwitch from "components/CollapseSwitch";

function SwitchPodeParticiparVotacao({
  control,
  watch,
  setField,
}: {
  control: any;
  watch: any;
  setField: any;
}) {
  return (
    <>
      <CollapseSwitch
        onChange={(v) => {
          setField("podeParticiparVotacao", v);
          setField("podeVotar", undefined);
        }}
        open={!!watch("podeParticiparVotacao")}
        title="Pode participar das assembléias"
      >
        {watch("podeParticiparVotacao") ? (
          <Box mt="16px">
            <Field
              control={control}
              shouldUnregister
              name="podeVotar"
              render={({ field }) => (
                <Checkbox
                  {...field}
                  onChange={() => field.onChange(!field.value)}
                  isChecked={!!field.value}
                >
                  Pode votar
                </Checkbox>
              )}
            ></Field>
          </Box>
        ) : null}
      </CollapseSwitch>
    </>
  );
}

export default SwitchPodeParticiparVotacao;
